import React from "react";
import {isArrayNullOrEmpty} from "../../../../Utilities/Types/arrayUtilities";
import {ButtonLinkStyle} from "../../../../Components/Inputs";
import {ownCatalogQueueModel} from "./ownQueueFactory";
import {OwnQueueItem} from "./OwnQueueItem";
import {getTotalCost} from "./ownQueueUtility";
import {GridCell} from "../../../../Components/Grid";
import {isRmtcAdmin} from "@/Utilities/LocalStorage/storageUtilities";

interface OwnQueueListProps {
    ownQueue: Record<string, any>[];
    handleDeselectAll?: () => void;
    handleRemoveFromQueue: (id: string) => void;
    handleSelectAll?: () => void;
    handleSelectedItemsChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    isPendingQueue?: boolean;
    selectedItems?: Set<string>;
    quantities?: Record<string, number | undefined>;
    getMaxQuantity?: (item: Record<string, any>) => number | undefined;
    handleQuantityChange?: (id: string, quantity: number | undefined) => void;
}

export const OwnQueueList = ({
                                 ownQueue,
                                 handleDeselectAll,
                                 handleRemoveFromQueue,
                                 handleSelectAll,
                                 handleSelectedItemsChange,
                                 isPendingQueue = true,
                                 selectedItems,
                                 quantities,
                                 getMaxQuantity,
                                 handleQuantityChange,
                             }: OwnQueueListProps) => {

    const isOwnQueueEmpty = isArrayNullOrEmpty(ownQueue);
    const canViewCost = isRmtcAdmin();

    return <>
        <header>
            <h2> {isPendingQueue ? `Pending` : `Processing`}</h2>
        </header>
        {
            isPendingQueue && !isOwnQueueEmpty && canViewCost &&
            <GridCell className={`h3 align-right`}>
                {
                    <p className={`text-muted`}>Total Cost: {getTotalCost(ownQueue)}</p>
                }
            </GridCell>
        }
        {
            !isOwnQueueEmpty && handleSelectAll && handleDeselectAll &&
            <>
                <ButtonLinkStyle isCollapsed onClick={handleSelectAll} name={`btnSelectAll`}
                                 label={`Select All`}/> /&nbsp;
                <ButtonLinkStyle isCollapsed onClick={handleDeselectAll} name={`btnDeselectAll`}
                                 label={`Deselect All`}/>
            </>
        }
        {
            !isOwnQueueEmpty && ownQueue &&
            ownQueue.map((ownQueuedItem: Record<string, any>) => {

                const {ownCatalogItem, ownQueueItemId} = ownQueuedItem;
                const queueModel = ownCatalogQueueModel({...ownCatalogItem, ...ownQueuedItem});
                const handleDelete = () => handleRemoveFromQueue(ownQueueItemId);
                const isSelected = selectedItems?.has(ownQueueItemId);
                const maxQuantity = getMaxQuantity ? getMaxQuantity(ownQueuedItem) : undefined;
                const storedQuantity = Number(ownQueuedItem.quantity) || 1;
               
                const currentQuantity = !isPendingQueue
                    ? storedQuantity
                    : maxQuantity === undefined
                        ? quantities?.[ownQueueItemId]
                        : quantities?.[ownQueueItemId] ?? storedQuantity;

                return <OwnQueueItem
                    key={ownQueueItemId}
                    {...queueModel}
                    ownCatalogItemId={String(queueModel.ownCatalogItemId || '')}
                    ownQueueItemId={String(ownQueueItemId || '')}
                    title={String(queueModel.title || '')}
                    details={String(queueModel.details || '')}
                    handleDelete={handleDelete}
                    handleSelectedItemsChange={handleSelectedItemsChange}
                    isPendingQueue={isPendingQueue}
                    isSelected={isSelected}
                    quantity={currentQuantity}
                    maxQuantity={maxQuantity}
                    handleQuantityChange={handleQuantityChange}
                />;
            })
        }
        {
            isOwnQueueEmpty &&
            <p className={`text-center`}>No results.</p>
        }
        <br/>
        <br/>
    </>;
};
